"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _helper = _interopRequireDefault(require("./helper"));

var _modal = _interopRequireDefault(require("../../../core/modal"));

var _PageLoader = _interopRequireDefault(require("../../../core/PageLoader"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../../../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind.default.bind(_indexModule.default);

const ERROR = 'Cannot load addresses';
const LIMIT = 5,
      PAGE = 0;
const DEFAULT_HD_PATH = "m/44'/60'/0'/0";
const DEFAULT_STATE = {
  addressList: [],
  i: 0,
  dpath: DEFAULT_HD_PATH,
  limit: LIMIT,
  page: PAGE,
  loading: false,
  error: null
};

class ConfirmAddress extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "getAddress", (data, limit, page, callback) => {
      let _callback = (er, addresses) => {
        if (er) return callback(er, null);
        let re = [];

        for (let i = 0; i < addresses.length; i++) {
          let address = addresses[i];
          re[i] = {
            address: address
          };

          _helper.default.getBalance(address).then(balance => {
            re[i].balance = balance;
            return callback(null, re);
          }).catch(er => {
            re[i].balance = 0;
            return callback(null, re);
          });
        }
      };

      if (data.wallet === 'isoxys') {
        _helper.default.getAddressByIsoxys(data, this.state.dpath, limit, page).then(re => {
          return _callback(null, re);
        }).catch(er => {
          if (er) return _callback(ERROR, null);
        });
      } else if (data.wallet === 'ledger') {
        _helper.default.getAddressByLedger(data, this.state.dpath, limit, page).then(re => {
          return _callback(null, re);
        }).catch(er => {
          if (er) return _callback(ERROR, null);
        });
      } else if (data.wallet === 'trezor') {
        _helper.default.getAddressByTrezor(data, this.state.dpath, limit, page).then(re => {
          return _callback(null, re);
        }).catch(er => {
          if (er) return _callback(ERROR, null);
        });
      } else {
        return _callback(ERROR, null);
      }
    });

    _defineProperty(this, "onConfirm", () => {
      let index = this.state.i + this.state.limit * this.state.page;
      this.done(null, {
        dpath: this.state.dpath,
        index: index
      });
      this.setState(_objectSpread({}, DEFAULT_STATE));
    });

    _defineProperty(this, "onSelect", index => {
      this.setState({
        i: index
      });
    });

    _defineProperty(this, "onDpath", e => {
      this.setState({
        dpath: e.target.value
      }, () => {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setState({
            loading: true
          }, () => {
            this.getAddress(this.props.data, this.state.limit, this.state.page, (er, re) => {
              if (er) return this.setState({
                loading: false,
                error: er
              });
              return this.setState({
                loading: false,
                addressList: re,
                error: null
              });
            });
          });
        }, 1000);
      });
    });

    _defineProperty(this, "onPage", step => {
      let page = this.state.page + step;
      if (page < 0) page = 0;
      if (page == this.state.page) return;
      this.setState({
        loading: true
      }, () => {
        this.getAddress(this.props.data, this.state.limit, page, (er, re) => {
          if (er) return this.setState({
            loading: false,
            error: er
          });
          return this.setState({
            loading: false,
            page: page,
            addressList: re,
            error: null
          });
        });
      });
    });

    _defineProperty(this, "showAddresses", (defaultIndex, addressList) => {
      return addressList.map((item, index) => {
        return /*#__PURE__*/_react.default.createElement("label", {
          key: item.address,
          className: cx("radio-wrapper"),
          onChange: () => this.onSelect(index)
        }, item.address, " ", /*#__PURE__*/_react.default.createElement("br", null), " ", item.balance, " ETH", /*#__PURE__*/_react.default.createElement("input", {
          type: "radio",
          name: "address",
          value: item.address,
          checked: index === defaultIndex,
          readOnly: true
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: cx("checkmark")
        }));
      });
    });

    this.state = _objectSpread({}, DEFAULT_STATE);
    this.done = props.done;
    this.onClose = props.onClose;
  }

  componentDidMount() {
    this.setState({
      loading: true
    }, () => {
      this.getAddress(this.props.data, this.state.limit, this.state.page, (er, re) => {
        if (er) return this.setState({
          loading: false,
          error: er
        });
        return this.setState({
          loading: false,
          addressList: re,
          error: null
        });
      });
    });
  } // UI conventions


  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: true,
      className: cx("fade", "wallet-modal", "choose-wallet-address"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cx("close-button"),
      onClick: this.onClose
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "mt-4")
    }, "Choose Your Wallet Address"), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("position-absolute"),
      style: {
        cursor: "pointer",
        color: "black",
        top: "12px",
        left: "12px"
      },
      onClick: window.kambriaWallet.back
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: cx("fas", "fa-arrow-left")
    }), " Back"), /*#__PURE__*/_react.default.createElement("input", {
      className: cx("form-control", "mb-4"),
      type: "text",
      value: this.state.dpath,
      onChange: this.onDpath
    }), this.state.loading ? /*#__PURE__*/_react.default.createElement(_PageLoader.default, {
      type: "bar"
    }) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("addresses")
    }, this.showAddresses(this.state.i, this.state.addressList)), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("d-inline", "text-left", "mr-1", "btn", "btn-primary-gray", "btn-sm"),
      onClick: () => {
        this.onPage(-1);
      }
    }, "<"), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("d-inline", "text-left", "mr-1", "btn", "btn-primary-gray", "btn-sm")
    }, this.state.page + 1), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("d-inline", "text-left", "mr-1", "btn", "btn-primary-gray", "btn-sm"),
      onClick: () => {
        this.onPage(1);
      }
    }, ">"), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("d-inline", "text-left", "float-right", "btn", "btn-primary", "btn-sm"),
      onClick: this.onConfirm
    }, "OK")));
  }

}

var _default = ConfirmAddress;
exports.default = _default;